import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import apiService from '../../utils/api'; 
import './ProjectEmailPopup.css';
import { CustomSelect } from './CreateBlankModal'; 
import Snackbar from '@mui/material/Snackbar'; 

const ClientPopup = ({ isOpen, onClose,onSave}) => {
  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [partnerId, setPartnerId] = useState(null);
  const [partnerEmail, setPartnerEmail] = useState('');
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [isPartnersLoading, setIsPartnersLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const storedUserId = sessionStorage.getItem('user_id') || '';
    setUserId(storedUserId);
  }, []);
  
  useEffect(() => {
    if (!userId) return;
    const fetchUsers = async () => {
      try {
        setIsPartnersLoading(true);
        const response = await apiService.fetchData('user/all');
        const allUsers = response?.data || [];
        setPartnerOptions(
          allUsers.map(user => ({
            label: user.email || user.user_email,
            value: user.user_id,
            id: user.user_id,
          }))
        );
      } catch (error) {
        console.error('Error fetching users for client partner dropdown:', error);
      } finally {
        setIsPartnersLoading(false);
      }
    };
    fetchUsers();
  }, [userId]);

// When value changes, keep partnerId in sync if needed (value is user_id already)
useEffect(() => {
  if (!partnerEmail) {
    setPartnerId(null);
    return;
  }
  setPartnerId(partnerEmail);
}, [partnerEmail]);

  if (!isOpen) return null;

  
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!clientName) {
    setSnackbarMessage('Please fill all required fields');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  // Ensure partnerId is fetched before proceeding if provided
  if (partnerEmail && !partnerId) {
    setSnackbarMessage('Invalid client partner email or still loading');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  const payload = {
    user_id: userId,
    client_details: {
      name: clientName,
      code: clientEmail,
      partner_id: partnerId,
    },
  };

  console.log("Submitting payload:", payload);

  try {
    setIsLoading(true);
    const res = await apiService.postData("add_client", payload, true);
    console.log("API Response:", res);
    if (res?.status === "success") {
      const newClient = {
    client_id: res?.data?.client_id || res?.client?.client_id || Date.now().toString(),
    clientName: clientName,
    clientEmail: clientEmail,
    salesRepresentativeEmail: partnerEmail,
  };
  setSnackbarMessage('Client added successfully');
  setIsSuccess(true);
  setSnackbarOpen(true);
  setClientName('');
  setClientEmail('');
  setPartnerEmail('');
  if (onSave) {
    onSave(newClient);
  }
  onClose();
    } else {
      setSnackbarMessage(res?.message || 'Failed to save client');
      setIsSuccess(false);
      setSnackbarOpen(true);
    }
  } catch (error) {
    console.error("Error saving client:", error);
    setSnackbarMessage('Error saving client: ' + error.message);
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cbm-modal-header">
          <h2>Add New Client</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Client Name <span className="required-asterisk">*</span></label>
            <input
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Enter client name"
              required
            />
          </div>
          <div className="form-group">
            <label>Client Email</label>
            <input
              type="email"
              value={clientEmail}
              onChange={(e) => setClientEmail(e.target.value)}
              placeholder="Enter client email"
            />
          </div>
        <div className="form-group">
  <label>Client Partner Email</label>
  <div className="dropdown-container" style={{ position: 'relative' }}>
    <CustomSelect
      options={partnerOptions}
      value={partnerEmail}
      placeholder="Select Client Partner Email"
      disabled={isPartnersLoading}
      onChange={(val) => {
        setPartnerEmail(val);
        const selectedOption = partnerOptions.find(opt => opt.value === val);
        setPartnerId(selectedOption ? selectedOption.id : null);
      }}
      renderAsSpan={true}
    />
    {isPartnersLoading && (
      <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
        <CircularProgress size={16} style={{ color: '#ff6b35' }} />
      </div>
    )}
  </div>
</div>

          <div className="client-form-actions">
            <button type="submit" className="modal-action-btn modal-action-btn-save" disabled={isLoading}>
              {isLoading ? (
                <>
                  <CircularProgress size={20} style={{ marginRight: '8px', color: 'white' }} />
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
            <button
              type="button"
              className="modal-action-btn modal-action-btn-cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClientPopup;
